import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { UtilityService } from '../../../services/utility.service';
import { apiErrorHandler } from '../../../constants/api-error-handler';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Location } from '@angular/common';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-sso-login',
  standalone: true,
  imports: [MatProgressBarModule],
  templateUrl: './sso-login.component.html',
  styleUrls: ['./sso-login.component.scss'],
})
export class SsoLoginComponent {
  redirect_url: string;
  return_url: string;
  meriPehchanUrl: string;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private utilService: UtilityService,
    protected location: Location,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.route.queryParams.subscribe((params) => {
        this.redirect_url = params['redirect_url'];
        this.return_url = params['return_url'];

        localStorage.setItem('url_redirect', this.redirect_url);
        localStorage.setItem('return_url', this.return_url);

        this.getMeriPehchanUrl();
      });
    }
  }

  getMeriPehchanUrl() {
    if (isPlatformBrowser(this.platformId)) {
      this.apiService.fetchNssoAuth().subscribe({
        next: (res) => {
          this.meriPehchanUrl = res;
          this.utilService.openExternalPage(this.meriPehchanUrl);
        },
        error: apiErrorHandler.bind(this),
      });
    }
  }
}
